import { $MTS } from '@mts-fe/utils';

$MTS.App.init({ complete: () => console.debug('[$MTS.App] init') });

export const inMtsApp =
  $MTS.App.prop($MTS.PROP_PLATFORM) == $MTS.ANDROID || !!localStorage.getItem('MTS_APP');

/** 当前设备信息 */
export const deviceInfo = {
  deviceId: $MTS.App.prop($MTS.PROP_DEVICE_ID),
  deviceOsVersion: $MTS.App.prop($MTS.PROP_PLATFORM),
  devicePlatform: $MTS.App.prop($MTS.PROP_OS_VER),
  deviceShellVersion: $MTS.App.prop($MTS.PROP_SHELL_VER),
  deviceRam: $MTS.App.prop($MTS.PROP_RAM),
};
